import { ApolloLink } from 'apollo-link';

// Extensions (even an empty object) break deserialisation in the monolith graphql endpoint
export const deleteExtensionsLink = new ApolloLink((operation, forward) => {
	// @ts-ignore - See above comment
	delete operation.extensions;
	return forward(operation);
});
